module.exports = "/packs/media/images/icons/privacy-842425a8e5766a38af3164434531bd1e.png";